const BorderQR = () => {
  return (
    <svg
      width="205"
      height="205"
      viewBox="0 0 204 205"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.227539"
        width="203.544"
        height="204.998"
        rx="11.7836"
        fill="url(#paint0_linear_2345_174133)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2345_174133"
          x1="203.772"
          y1="213.591"
          x2="36.985"
          y2="-35.7318"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2568" />
          <stop offset="0.379185" stopColor="#0B1D93" />
          <stop offset="0.572275" stopColor="#0B1D93" />
          <stop offset="1" stopColor="#00C7F9" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default BorderQR;
